import { render, staticRenderFns } from "./MeusVouchers.vue?vue&type=template&id=21ab4886&scoped=true"
import script from "./MeusVouchers.vue?vue&type=script&lang=js"
export * from "./MeusVouchers.vue?vue&type=script&lang=js"
import style0 from "./MeusVouchers.vue?vue&type=style&index=0&id=21ab4886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ab4886",
  null
  
)

export default component.exports